module.exports = __webpack_public_path__ + "img/LMLOGO.a4ea89a1.svg";